<template>
  <div class="reportApplication">
    <commonHeader :explain="explain" :title="pageTitle" />
    <!-- 基本信息 -->
    <basicInformation ref="basicInformationRef" v-if="!$route.query.activityCode || editEchoData"
      :edit-echo-data="editEchoData" />
    <!-- 活动信息 -->
    <activityInformation ref="activityInformationRef" v-if="!$route.query.activityCode || editEchoData"
      :edit-echo-data="editEchoData" :setCacheList="setCacheList" :updateForm="updateForm"
      :inviterNum="lang === 'zh-CN' && true" />
    <!-- 费用归属 -->
    <!-- !$route.query.activityCode：表示不是编辑页 -->
    <!-- editEchoData：表示是编辑页并且请求数据成功 -->
    <!-- !needOrganizer：表示没有活动组支持 -->
    <!-- addCostEditFlag：表示活动组支持追加的费用可编辑 -->
    <costAscription ref="costAscriptionRef"
      v-if="(!$route.query.activityCode || editEchoData) && (!needOrganizer || addCostEditFlag)"
      :edit-echo-data="editEchoData" @checkAllsmartOrderVOListCommand="handleSuccessAllsmartOrderVOList" />
    <!-- 拟邀请客户 -->
    <userSelection ref="userSelectionRef" v-if="!$route.query.activityCode || editEchoData"
      :edit-echo-data="editEchoData" :cacheList="cacheList" :mustWrite="isMustWrite()" />
    <!-- 活动目录 -->
    <activityCatalogue ref="activityCatalogueRef"
      v-if="lang === 'zh-CN' && (!$route.query.activityCode || editEchoData)" :edit-echo-data="editEchoData"
      :cacheList="cacheList" :updateForm="updateForm" :setActivityForm="setActivityForm" />
    <!-- 活动附件 -->
    <activityFile ref="activityFileRef" v-if="!$route.query.activityCode || editEchoData" :edit-echo-data="editEchoData"
      :updateForm="updateForm" />
    <!-- 转申请操作按钮 -->
    <div class="buttons" v-if="$route.path === '/transferApplication'">
      <el-button plain @click="cancelReport">{{ $t('btn.CancelFil') }}</el-button>
      <el-button type="primary" @click="submitBtn">{{ $t('btn.TransferApp') }}</el-button>
    </div>
    <!-- 报备申请按钮 -->
    <div class="buttons" v-else>
      <el-button plain @click="saveBtn" v-if="saveBtnShow">{{ $t('btn.SaveD') }}</el-button>
      <el-button type="primary" @click="submitBtn">{{ $t('btn.Submit') }}</el-button>
    </div>
  </div>
</template>

<script>
import commonHeader from '@/components/commonHeader';
import basicInformation from './component/newApplicationForm/basicInformation';
import activityInformation from './component/newApplicationForm/activityInformation';
import userSelection from './component/newApplicationForm/userSelection';
import costAscription from './component/newApplicationForm/costAscription';
import { hasAllsmartOrder, confirmAllsmartOrderTimeout } from '@/utils/allsmartOrderCheck';
import { confirmPrecheck, confirmBusiness, notifyDetectFailed } from '@/utils/exportComplianceDialog';
import activityFile from './component/newApplicationForm/activityFile';
import activityCatalogue from './component/newApplicationForm/activityCatalogue.vue';
import { newApplicationFormApi, activityRuleApi } from './service';
import { mapState } from 'vuex';
import {isNotEmpty, throttle, throttleAsync} from '../../utils/utils';

export default {
  data() {
    return {
      pageTitle: this.$t('home.aff'),
      explain: {
        text: `${this.$t('notic.AppRule')}，`,
        content: this.$t('notic.AppRuleOne')
      },
      editEchoData: null,
      addCostEditFlag: false, // 活动组支持追加的费用是否可编辑
      saveBtnShow: false,
      isSubmitted: false, // 是否已提交：false离开页面会有提示保存信息
      lang: localStorage.getItem('lang') || "zh-CN",
      cacheList: {},
      cform: {},
      timeOut: null
    };
  },
  computed: {
    ...mapState({
      needOrganizer: (state) => state.newApplication.needOrganizer
    })
  },
  components: {
    commonHeader,
    basicInformation,
    activityInformation,
    userSelection,
    costAscription,
    activityFile,
    activityCatalogue
  },
  methods: {
    cancelReport() {
      this.$confirm(this.$t('newApp.Ycon'), this.$t('general.Hint'), {
        confirmButtonText: this.$t('btn.OK'),
        cancelButtonText: this.$t('btn.Cancel'),
        type: 'warning'
      }).then(() => {
        newApplicationFormApi.cancelReport(this.$route.query.activityCode).then(res => {
          if (res.status === '200') {
            this.$message.success(this.$t('general.OperSucc'));
            this.$router.push('/reportList');
          }
        });
      }).catch(() => {
      });
    },
    paramsHandler(saveType) {
      // saveType 保存类型 1-草稿  2-提交  3-品推编辑  4-驳回编辑  5-报备提交   6-报备草稿   7-报备编辑  8-报备转申请

      let params = {
        // 保存类型
        saveType: saveType
      };
      // 基本信息
      let basicInfoData = this.$refs.basicInformationRef.formData;

      // 活动信息
      let activityInfoData = this.$refs.activityInformationRef.formData;

      let activityCatalogueData = this.$refs.activityCatalogueRef?.formData;

      params.marketActivity = {
        // submitType 提交类型(页面类型) quick_submit-快速提交  普通提交-normal_submit  报备提交-report_submit  渠道提交-qd_submit
        submitType: 'report_submit',
        // 基本信息
        activityCode: basicInfoData.activityCode,
        financialSystemCode: basicInfoData.financialSystemCode,
        financialSystemName: basicInfoData.financialSystemName,
        currencyCode: basicInfoData.currencyCode,
        currencyType: basicInfoData.currencyType,
        currFromRmbRate: basicInfoData.currFromRmbRate,
        applyUserTel: basicInfoData.applyUserTel,
        applyTime: basicInfoData.applyTime,
        salerId: basicInfoData.salerId,
        salerName: basicInfoData.salerName,
        salerDeptCode: basicInfoData.salerDeptCode,
        salerDeptName: basicInfoData.salerDeptName,
        applyUserId: basicInfoData.applyUserId,
        applyUserName: basicInfoData.applyUserName,
        applyUserDeptCode: basicInfoData.applyUserDeptCode,
        applyUserDeptName: basicInfoData.applyUserDeptName,
        applyUserType: basicInfoData.applyUserType,
        // 活动信息
        activityName: activityInfoData.activityName,
        activityGoal: '市场活动类',
        businessUnit: activityInfoData.businessUnitDisplayed ? activityInfoData.businessUnitDisplayed.join(',') : '',
        activityClassificationCode: activityInfoData.activityClassificationCode,
        activityClassification: activityInfoData.activityClassification,
        relatedActivityCode: activityInfoData.relatedActivityCode,
        relatedActivityName: activityInfoData.relatedActivityName,
        hqActivityCode: activityInfoData.relatedActivityCode,
        hqActivityName: activityInfoData.hqActivityName,
        activityForms: activityInfoData.activityForms,
        organizer: activityInfoData.organizer,
        inviterNum: activityInfoData.inviterNum,
        targetObject: activityInfoData.targetObject,
        targetObjectOther: activityInfoData.targetObjectOther || '',
        activityTypeCode: activityInfoData.activityTypeCode,
        activityType: activityInfoData.activityType,
        qdMeetingSegment: activityInfoData.qdMeetingSegment,
        city: activityInfoData.city,
        expectStartDate: activityInfoData.expectStartDate,
        expectEndDate: activityInfoData.expectEndDate,
        isUnionMarket: activityInfoData.isUnionMarket,
        isInternationalQd: activityInfoData.isInternationalQd,
        unionChannelType: activityInfoData.unionChannelType,
        unionChannelName: activityInfoData.unionChannelName,
        needOrganizer: activityInfoData.needOrganizer,
        budgetAmount: activityInfoData.budgetAmount,
        organizerReason: activityInfoData.organizerReason,
        activityLevel: activityInfoData.activityLevel,
        // 邀请单位数：从活动目录数据中获取的单位数(dws)
        invitedUnitNum: activityCatalogueData?.dws,
        // 新业务机会数：从活动目录数据中获取的3个月内可能产生的新业务机会数量(create3m)
        newOpptyNum: activityCatalogueData?.create3m,
        // 推动业务机会数：从活动目录数据中获取的3个月内可能推动的业务机会数量(push3m)
        pushOpptyNum: activityCatalogueData?.push3m,
        // 新业务机会金额
        newOpptyAmount: activityCatalogueData?.create3mAmount || 0,
        // 推动业务机会金额
        pushOpptyAmount: activityCatalogueData?.push3mAmount || 0,
      };
      if (isNotEmpty(activityInfoData.mactCommunicationScenarioList)) {
        params.mactCommunicationScenarioList = activityInfoData.mactCommunicationScenarioList;
      }
      if (isNotEmpty(activityInfoData.mactAgendaList)) {
        params.mactAgendaList = activityInfoData.mactAgendaList;
      }
      // 活动信息-扩展表（后续新增的字段）
      params.marketActivityExpand = {
        activityCode: basicInfoData.activityCode,
        brandPromotionSupportKey: activityInfoData.brandPromotionSupportKey,
        brandPromotionSupport: activityInfoData.brandPromotionSupport,
        remotePoc: activityInfoData.remotePoc,
        unitedDiamondActivity: activityInfoData.unitedDiamondActivity,
        circleActivity: activityInfoData.circleActivity,
        templateVisit: activityInfoData.templateVisit,
        activityBaseName: activityInfoData.activityBaseName,
        activityBaseContactInformation: activityInfoData.activityBaseContactInformation,
        activityBaseUrl: activityInfoData.activityBaseUrl,
        activityBaseDeptCode: activityInfoData.activityBaseDeptCode,
        activityBackgroundPurpose: activityInfoData.activityBackgroundPurpose
      };

      // 活动预计包含板块
      params.mactModuleList = this.$refs.activityInformationRef.plateFilter();

      // 产品线
      params.mactProductLineList = this.$refs.activityInformationRef.productlineSupplementFilter();

      // 拟邀客户
      params.mactJoinCustomerList = this.$refs.userSelectionRef ? this.$refs.userSelectionRef.getTableData() : [];
      if (isNotEmpty(params.mactJoinCustomerList)) {
        params.mactJoinCustomerList.forEach(item => {
          item.phone = item.telephone;
          item.mustFollowCustomer = item.mustFollowC;
          if (typeof item.opportunityName !== 'string') {
            item.opportunityName = item.opportunityName?.join(',')
          }
        });
      }
      // 费用归属
      // 如果不是活动组支持 || 是活动组支持追加的费用可编辑
      if (!this.needOrganizer || this.addCostEditFlag) {
        params.mactExpenseBelongVOList = this.$refs.costAscriptionRef.tableData.map(item => {
          return {
            mactExpenseBelong: {
              ...item,
              activityCode: basicInfoData.activityCode,
              // 如果是转申请则报备申请金额不能修改，则取后台返回的金额
              reportApplyAmount: this.$route.path === '/transferApplication' ? item.reportApplyAmount : item.activityCost
            },
            activityExpenseDetails: item.activityExpenseDetails,
            advertiseExpenseDetails: item.advertiseExpenseDetails,
            allsmartOrderVOList: item.allsmartOrderVOList
          };
        });
        // 费用归属总计
        params.marketActivity.totalCost = this.$refs.costAscriptionRef.costTotal;
      } else {
        params.mactExpenseBelongVOList = [];
      }

      // 活动附件
      if (this.$refs.activityFileRef.fileList.length > 0) {
        params.attachFileList = this.$refs.activityFileRef.fileList.map(item => {
          return {
            fileId: item.response ? item.response.data[0].FID : item.fileId,
            fileName: item.name,
            activityCode: basicInfoData.activityCode,
            sourceType: 'Activity'
          };
        });
      }
      return params;
    },
    validateScrollJump(ele, scrollbarData) {
      let eleInfo = ele.$el.getBoundingClientRect();
      if (eleInfo.top < 0) {
        scrollbarData.scrollTop = scrollbarData.scrollTop - (eleInfo.height / 2) - Math.abs(eleInfo.top);
      }
    },
    async subValidate() {
      let mainScrollbar = document.querySelector('.contentScrollbar>.el-scrollbar__wrap');

      // 基本信息校验
      let basicInfoValidate = await this.$refs.basicInformationRef.validateHandler();
      if (!basicInfoValidate) {
        this.validateScrollJump(this.$refs.basicInformationRef, mainScrollbar);
        return;
      }

      // 活动信息校验
      let activityInfoValidate = await this.$refs.activityInformationRef.validateHandler();
      if (!activityInfoValidate) {
        this.validateScrollJump(this.$refs.activityInformationRef, mainScrollbar);
        return;
      }

      // 费用归属校验
      if (!this.needOrganizer || this.addCostEditFlag) {
        let costValidate = await this.$refs.costAscriptionRef.validateHandler();
        if (!costValidate) return;
      }

      // 活动目标校验
      let activityCatalogueValidate = await this.$refs.activityCatalogueRef.validateHandler();
      if (!activityCatalogueValidate) {
        this.validateScrollJump(this.$refs.activityCatalogueRef, mainScrollbar);
        return;
      }

      // 活动附件校验
      let fileValidate = await this.$refs.activityFileRef.validateHandler();
      if (!fileValidate) return;

      return true;
    },
    // 礼品库内容检测
    async checkAllsmartOrderVOList(type) {
      const { dataList } = this.$refs.costAscriptionRef.$refs.costAscriptionTable.tableData;
      dataList.forEach(item => {
        this.$refs.costAscriptionRef.getDetailCommand(item, type);
      });
    },
    // 接口处理事件
    handleSuccessAllsmartOrderVOList: throttleAsync(async function () {
      let validateResult = await this.subValidate();
      if (!validateResult) return;
      let { path } = this.$route;
      let saveType = 5;
      if (path === '/editReportApplication') {
        saveType = 7;
      } else if (path === '/transferApplication') {
        saveType = 8;
      }
      // 报备转申请时，礼品汇超时规则确认弹窗
      if (saveType === 8) {
        const { dataList } = this.$refs.costAscriptionRef.$refs.costAscriptionTable.tableData;
        const confirmed = await confirmAllsmartOrderTimeout(this, hasAllsmartOrder(dataList));
        if (!confirmed) return;
      }
      let params = this.paramsHandler(saveType);
      newApplicationFormApi.verificationActivity(params).then(res => {
        confirmPrecheck(this, res, {
          originalBizId: (params.marketActivity && params.marketActivity.activityCode) || ''
        }).then(confirmed => {
          if (confirmed) {
            this.submitRequestCommand(params, path);
          }
        });
      }).catch(() => {
        notifyDetectFailed(this);
      });
    }, 500),
    submitRequestCommand(params, path) {
      if (this.lang === 'zh-CN' && (!this.$route.query.activityCode || this.editEchoData)) {
        let activityCatalogueData = this.$refs.activityCatalogueRef.formData;
        // activityCatalogueData.create3m或者activityCatalogueData.push3m为0则弹窗提示
        if (activityCatalogueData.create3m === 0 || activityCatalogueData.push3m === 0) {
          this.$confirm(this.$t('notic.applicationUpload'), this.$t('general.Hint'), {
            confirmButtonText: this.$t('btn.OK'),
            cancelButtonText: this.$t('btn.Cancel'),
            type: 'warning'
          }).then(async () => {
            this.reportSubimtApi(params, path)
          }).catch(() => {
          });
        } else {
          this.reportSubimtApi(params, path)
        }
      } else {
        this.reportSubimtApi(params, path)
      }
    },
    reportSubimtApi(params, path) {
      this.$store.commit('setSubPageLoading', true);
      newApplicationFormApi.reportSubimt(params).then(res => {
        this.$store.commit('setSubPageLoading', false);
        confirmBusiness(this, res).then(passed => {
          if (passed) {
            this.isSubmitted = true;
            this.$message.success(this.$t('general.SubSucc'));
            // 如果是转申请，提交成功则跳转至活动列表页
            if (path === '/transferApplication') {
              this.$router.push('/activityQuery');
            } else {
              this.$router.push('/reportList');
            }
          }
        });
      });
    },
    isMustWrite() {
      if (!this.$refs.costAscriptionRef?.tableData) return false;
      let isMust = false
      let isNextList = '000062689;000062692;000062730;000062698;000062699;000062703;000062705;000062706'.split(';')
      // this.$refs.costAscriptionRef.tableData
      for (let refTableRow of this.$refs.costAscriptionRef.tableData) {
        // 如果refTableRow.deptCode>9则取前九位，与isNextList做匹配，如果匹配成功则isMust为true
        if (refTableRow.deptCode > 9) {
          let deptCode = refTableRow.deptCode.toString().substring(0, 9)
          if (isNextList.includes(deptCode)) {
            isMust = true
          }
        }
      }
      return isMust
    },
    submitBtn: throttle(function () {
      const routeUrlList = ['/reportApplication', '/editReportApplication'];
      // let validateResult = false;
      if (!routeUrlList.includes(this.$route.path)) {
        this.checkAllsmartOrderVOList('submit');
      } else {
        // validateResult =
        this.handleSuccessAllsmartOrderVOList();
      }


      // console.log(this.lang === 'zh-CN' && (!this.$route.query.activityCode || this.editEchoData))
      // console.log(this.lang === 'zh-CN', !this.$route.query.activityCode, this.editEchoData)


      // if (this.lang === 'zh-CN' && (!this.$route.query.activityCode || this.editEchoData)) {
      //   let activityCatalogueData = this.$refs.activityCatalogueRef.formData;
      //   // activityCatalogueData.create3m或者activityCatalogueData.push3m为0则弹窗提示
      //   if (activityCatalogueData.create3m === 0 || activityCatalogueData.push3m === 0) {
      //     this.$confirm(this.$t('notic.applicationUpload'), this.$t('general.Hint'), {
      //       confirmButtonText: this.$t('btn.OK'),
      //       cancelButtonText: this.$t('btn.Cancel'),
      //       type: 'warning'
      //     }).then(async () => {
      //       // await this.checkAllsmartOrderVOList('submit');

      //       if (!routeUrlList.includes(this.$route.path)) {
      //         this.checkAllsmartOrderVOList('submit');
      //       } else {
      //         this.handleSuccessAllsmartOrderVOList();
      //       }
      //     }).catch(() => {
      //     });
      //   } else {
      //     // await this.checkAllsmartOrderVOList('submit');
      //     if (!routeUrlList.includes(this.$route.path)) {
      //       this.checkAllsmartOrderVOList('submit');
      //     } else {
      //       this.handleSuccessAllsmartOrderVOList();
      //     }
      //   }
      // } else {
      //   // await this.checkAllsmartOrderVOList('submit');
      //   if (!routeUrlList.includes(this.$route.path)) {
      //     this.checkAllsmartOrderVOList('submit');
      //   } else {
      //     this.handleSuccessAllsmartOrderVOList();
      //   }
      // }


    }, 1000),
    saveBtn: throttle(function () {
      let fileValidate = this.$refs.activityFileRef.validateHandler();
      if (!fileValidate) return;

      let params = this.paramsHandler(6);

      newApplicationFormApi.reportSubimt(params).then(res => {
        confirmBusiness(this, res).then(passed => {
          if (passed) {
            this.isSubmitted = true;
            this.$message.success(this.$t('general.SaveSucc'));
            this.$router.push('/drafts');
          }
        });
      });
    }, 1000),
    getEchoData() {
      this.$store.commit('setSubPageLoading', true);
      newApplicationFormApi.getMarketActivityData(this.$route.query.activityCode).then(res => {
        this.$store.commit('setSubPageLoading', false);
        if (res.status === '200') {
          if (isNotEmpty(res.data)) {
            if (isNotEmpty(res.data.mactJoinCustomerList)) {
              res.data.mactJoinCustomerList.forEach(item => {
                item.telephone = item.phone;
                item.mustFollowC = item.mustFollowCustomer;
              });
            }
          };
          this.editEchoData = res.data;
          // 是否需要活动组支持
          this.$store.commit('newApplication/setNeedOrganizer', res.data.marketActivity.needOrganizer);
          if (res.data.marketActivity.needOrganizer) {
            // 活动组支持追加的费用是否可编辑
            // 000 为总部报备活动
            this.addCostEditFlag = res.data.mactExpenseBelongVOList.some(item => {
              return item.allowEdit && item.mactExpenseBelong.deptCode !== '000';
            });
          }
        }
      });
    },
    setCacheList(key, value) {
      this.$set(this.cacheList, key, value);
    },
    updateForm(form) {
      this.cform = { ...this.cform, ...form, }
    },
    /**
     * @description: 将拟邀请总人数提交到活动信息模块中与之前逻辑统一
     * @param {*} key 需要修改的activityInformation中的formData中的key
     * @param {*} value 需要修改为的对应值
     */
    setActivityForm(key, value) {
      this.$refs.activityInformationRef.updateValue(key, value)
    }
  },
  mounted() {
    // 保存按钮显示隐藏：如果是申请页面
    this.saveBtnShow = this.$route.path === '/reportApplication';

    // 如果申请页面
    // 只有每月的20号-30/31号才可以报备申请
    if (this.$route.path === '/reportApplication') {
      let currentDay = new Date().getDate();
      if (currentDay < 1) {
        this.$alert(this.$t('notic.AppNotic'), this.$t('general.Hint'), {
          confirmButtonText: this.$t('btn.OK'),
          showClose: false,
          showCancelButton: false
        }).then(() => {
          this.$router.push('/home');
        }).catch(() => {

        });
      }
    }

    if (this.$route.query.activityCode) {
      this.pageTitle = this.$t('general.ReportEditor');
      this.isSubmitted = true;
      this.getEchoData();
      if (sessionStorage.getItem('applicationEditFlag')) {
        this.$store.commit('newApplication/setEditFlag', Number(sessionStorage.getItem('applicationEditFlag')));
      }
      window.addEventListener('beforeunload', () => {
        sessionStorage.setItem('applicationEditFlag', this.$store.state.newApplication.editFlag);
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    // 如果没有提交并且填写了活动名称，则提示该信息
    if (!this.isSubmitted && this.$refs.activityInformationRef.formData.activityName) {
      this.$confirm(this.$t('general.OKSad'), this.$t('general.Hint'), {
        confirmButtonText: this.$t('btn.OK'),
        cancelButtonText: this.$t('btn.Cancel'),
        type: 'warning'
      }).then(() => {
        this.saveBtn().then(() => {
          next();
        });
      }).catch(() => {
        next();
      });
    } else {
      sessionStorage.removeItem('applicationEditFlag');
      this.$store.commit('newApplication/setEditFlag', 0);
      next();
    }
  },

  watch: {
    cform: {
      handler(newVal, oldVal) {
        if (this.lang !== 'zh-CN') return
        if (this.timeOut) {
          clearTimeout(this.timeOut)
        }
        this.timeOut = setTimeout(() => {
          const form = {
            activityClassify: newVal.activityClassification, //活动分类
            activityForm: newVal.activityForms, //活动形式
            sponsor: newVal.organizer, //主办方
            invitePeopleNum: newVal.inviterNum, //拟邀请人数
            mainTarget: newVal.targetObject, //主要目标对象
            activityType: newVal.activityType, //活动类型
            inviteUnitsNum: newVal.dws, //拟邀请单位数
            threeMonthsNewOpp: newVal.create3m, //三个月内预计新建业务机会
            threeMonthsPromoteOpp: newVal.push3m //预计三个月内推动业务机会数
          }

          activityRuleApi.matchRule(form).then(res => {
            console.log(res)
            const val = res.data === null ? 'B' : res.data
            if (this.$refs.activityInformationRef) {
              this.$refs.activityInformationRef.updateValue('activityLevel', val)
            }
          })
        }, 1000)
      },
      deep: true
    },

  },
};
</script>

<style scoped>
.reportApplication .buttons {
  text-align: center;
}
</style>
